import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon, Table, DLMenu, YouTubeCoverImage } from 'appSrc/components/UI';
import TextTruncate from 'react-text-truncate';
// import EditModal from '../../Modals/VideoTranscript/EditModal';
import { parseYouTubeUrl } from 'appSrc/utils';
import style from './styles/style.module.css';

class SortableReviewsTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            reviewInEdit: null,
            reviewInEditIndex: -1,
        };
    }
    openEditModal = ( index, review ) => {
        this.setState( { reviewInEdit: review, reviewInEditIndex: index } );
    }
    onEditSubmit = ( updatedReview ) => {
        var index = this.state.reviewInEditIndex;
        this.props.onReviewUpdated( index, updatedReview );
        this.setState( { reviewInEdit: null, reviewInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { reviewInEdit: null, reviewInEditIndex: -1 } );
    }

    render() {
        const { transcripts } = this.props;

        return (
            <div>
                <Table
                className={ style.reviewsTable }
                loadMore={ this.props.loadMore }
                elementHeight={ 70 }>
                    <Table.Head>
                        <Table.Row draggable={ false }>
                            <Table.Cell>TYPE</Table.Cell>
                            <Table.Cell>TEXT</Table.Cell>
                            <Table.Cell className={ style.actionsCell }>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.SortableBody onChange={ this.props.onSort }>
                        { this.arrayTableRows( transcripts ) }
                    </Table.SortableBody>
                </Table>
                { /* this.state.reviewInEdit &&
                    <EditModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    review={ this.state.reviewInEdit } /> */
                }
            </div>
        );
    }

    arrayTableRows = ( items ) => {
        var rows = items.map( ( item, index ) => {
            return (
                <Table.Row key={ item.id }>
                    <Table.Cell>
                        { item.name }
                    </Table.Cell>
                    <Table.Cell>
                        <TextTruncate
                        line={ 2 }
                        text={ item.text } />
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, item );
                            } }/>
                        </DLMenu>
                    </Table.Cell>
                </Table.Row>
            );
        } );

        return rows;
    }
}
SortableReviewsTable.defaultProps = {
    onReviewUpdated: ()=>{},
};

export default connect()( SortableReviewsTable );
